import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { TOUR_REPLAY_EVENT } from 'components/shared/tour/RoleTour';

/**
 * Relanza el tutorial guiado del rol (mismo evento que el botón del sidebar). Se muestra en el
 * "Más" móvil para que la guía también sea accesible y testeable en móvil.
 */
function MoreTourButton() {
  const { t } = useTranslation(['tour']);
  const replay = () => window.dispatchEvent(new Event(TOUR_REPLAY_EVENT));

  return (
    <Button
      fullWidth
      color="inherit"
      startIcon={<HelpOutline />}
      onClick={replay}
      data-tour="tour-replay"
      sx={{ justifyContent: 'flex-start', color: 'text.primary', textTransform: 'none', fontWeight: 600, px: 0, py: 1 }}>
      {t('replay', { ns: 'tour', defaultValue: 'Ver tutorial guiado' })}
    </Button>
  );
}

export default MoreTourButton;
